(function () {
	angular
		.module('trackeye')
		.factory('ConfigurationCollection', _ConfigurationCollectionFactory);

	_ConfigurationCollectionFactory.$inject = ['Configuration', 'C4ApiService'];

	function _ConfigurationCollectionFactory(Configuration, api) {
		function ConfigurationCollection() {
			this.list = [];
		}

		/**
		 * Adds a one or more objects, containing configuration data to the list
		 * @param {(Object|Object[]|Configuration|Configuration[])} [data=Resource]
		 * @return {ConfigurationCollection}
		 */
		ConfigurationCollection.prototype.add = function (data) {
			if (!(data instanceof Array))
				data = [data];

			for (var i = 0; i < data.length; i++) {
				var config = data[i];
				if (config instanceof Configuration) {
					this.list.push(config);
				} else {
					this.list.push(
						(new Configuration()).populate(config)
					);
				}
			}

			return this;
		};

		ConfigurationCollection.prototype.delete = function (uuid) {
			var config = this.find(uuid);

			if (config) {
				return config.delete();
			}
		};
		/**
		 * Find a configuration by uuid
		 * @param  {string} [uuid=76a17d1d-1618-4bce-849e-34e77fa65f19] - Configuration uuid
		 * @return {Configuration} Configuration instance
		 */
		ConfigurationCollection.prototype.find = function (uuid) {
			return this._traverseList('id', uuid);
		};

		/**
		 * Find a configuration by name
		 * @param  {string} value [name=my-conf] - Name of the configuration
		 * @returns {Configuration|Configuration[]} Array of Configuration instances
		 */
		ConfigurationCollection.prototype.findByName = function (value) {
			return this._traverseList('name', value, true);
		};

		/**
		 * Find a single configuration by name, the first match is returned, even if more is found.
		 * @param value
		 * @returns {Configuration}
		 */
		ConfigurationCollection.prototype.findOneByName = function (value) {
			return this._traverseList('name', value)
		};

		ConfigurationCollection.prototype._traverseList = function (prop, value, many) {
			var matches = [];
			for (var i = 0; i < this.list.length; i++) {
				if (this.list[i].hasOwnProperty(prop) && this.list[i][prop] === value) {
					if (!many)
						return this.list[i];

					matches.push(this.list[i]);
				}
			}

			if (!many)
				return null;

			return matches;
		};

		return ConfigurationCollection;
	}
}());